const common_en = {
  user_name: "user name",
  password: "password",
  login: "login",
  user_email: "email",
  confirm_password: "confirm password",
  logged_in_successfully: "logged in successfully",
  registered_successfully: "registered sucessfully",
  saved_successfully: "saved sucessfully",

  // shutterB registration----------------------------------------------------------
  first_name: "first name",
  last_name: "last name",
  current_address: "current address",
  please_enter_first_name: "please enter first name",
  please_enter_last_name: "please enter last name",
  please_enter_current_address: "please enter current address",
  please_enter_email: "please enter your email",
  please_enter_instagram: "please enter your instagram handle",
  please_enter_distance: "please enter distance",
  please_enter_phone_number: "please enter your phone number",
  invalid_registration_image_count: "invalid registration image count",
  max_3_photos_can_be_selected: "max 3 photos can be selected",
  please_select_image: "please select image",
  invalid_file_type: "invalid file type, allowed files are JPG/PNG",
  form_submitted_successfully: "form submitted successfully",

  // login signup
  account_selection_heading: "log in to access your account",
  client: "client",
  shutterb: "shutterb",
  continue: "continue",
  // enter_a_location: from event form,
  distance_willing_to_travel: "distance willing to travel",
  email_address: "email address",
  instagram_handle: "instagram handle",
  phone_number: "phone number",
  current_smartphone: "current smartphone",
  please_select_smart_phone: "please select smart phone",
  shutterb_question_1: "why do you want to work for shutterb?",
  shutterb_question_1_description:
    "tell us why you’d fit into our community of go-getting, creative and talented individuals. we’re not only looking for good smartphone content creators, we are also looking for people who are personable, professional and passionate about doing what they love!",
  shutterb_question_2:
    "why do you think you’ll be a great smartphone content creator?",
  shutterb_question_2_description:
    "tell us what you like about smartphone content creation.  what’s your style and how do you approach it?  do you have any smartphone accessories that enhance your capabilities as a smartphone content creator?",
  shutterb_question_3:
    "have you ever worked independently as a gig worker / freelancer before?",
  shutterb_question_3_description:
    "what did you think about it? what were the benefits? what were the drawbacks?",
  shutterb_question_4:
    "how many hours do you plan to devote to shutterb a week?",
  shutterb_question_4_description:
    "when you’re a shutterb you need to commit to a minimum 1 x 3 hour window of availability per week, but we encourage you to make yourself as available as you can be!",
  referral_name: "referral name",
  upload_image_msg:
    "upload 3 photos you’ve taken that best represent your ability to capture moments. photos must include shots of people to really demonstrate your eye!",
  select_multiple_files: "select multiple files",
  submit_application: "submit application",
  already_booked: "event already booked",
  event_cancellation_failed: "event cancellation failed",
  event_cancel_successfully: "event cancel successfully",
  // Shutterb dashboard-----------------------------------------
  profile_name: "profile name",
  this_field_is_required: "this field is required",
  invalid_field: "this field is invalid",
  bio: "bio",
  portfolio_images: "portfolio images",
  portfolio_images_description:
    "please select a minimum of 8, maximum of 12 images for your portfolio page. hosts will get to review available shutterbz in their area so make sure you’re choosing images that will help you stand out and really show your style! these images must be taken from your current smartphone.",
  device_type: "device type",
  language_spoken: "language spoken",
  additional_equipment: "additional equipment (optional)",
  additional_equipment_description:
    "if you have smartphone camera accessories that you feel will up your game and offer hosts an elevated experience feel free to add it here!",
  save: "save",
  save_and_preview: "save and preview",
  preview: "preview",
  my_info_heading_msg:
    "this is your personal info for our records. this will not be shared with event hosts.",
  home_address: "home address",
  primary_phone_number: "primary phone number",
  emergency_contact_name: "emergency contact name",
  emergency_contact_number: "emergency contact number",
  stripe_btn_msg:
    "click below to update your banking info with our payment fulfillment partners stripe connect.",
  connected: "connected",
  img_successfully_deleted: "files successfully deleted",
  max_img_error: "maximum 24 (images, videos and recaps) are allowed",
  successfully_checked_out: "successfully checked out",
  successfully_checked_in: "successfully checked in",
  file_successfully_deleted: "file successfully deleted",
  someone_not_checkout_from_event: "someone not checkout from event.",
  invalid_image_type: "unsupported image format.",
  max_distance_cannot_be_less_than_min_distance:
    "travel distance for 2hrs+ event cannot be less than 1 hour event",

  //customer dashboard------------------------------------------------------------------
  please_select_tip: "please select tip amount.",
  please_select_shutterb: "please select atleast 1 shutterb.",
  please_select_shutterb_with_valid_price:
    "please select atleast 1 shutterb with tip price 3 dollar minimum.",
  already_exists: "action already perfomred on this shutterb.",
  address: "address",
  city: "city",
  postal_code: "postal code",
  province: "province",
  country: "country",
  update: "update",
  current_password: "current password",
  new_password: "new password",
  confirm_new_password: "confirm new password",
  password_instruction_error:
    "must contain a number, a special character, a upper case letter, a lower case letter and minimum 6 characters",
  updated_successfully: "updated successfully",
  password_updated_successfully: "password updated successfully",
  password_not_matched: "current password is incorrect.",
  refer_to_friend_successfully: "invitation send successfully.",
  review_submit_successfully: "review submitted successfully.",
  invalid_eventid: "invalid event id",

  //event booking form------------------------------------------------------------------
  event_booking_form: "event booking form",
  book_your_event: "book your event",
  select_your_shutterb: "select your shutterb",
  event_details: "shot list and additional details",
  add_recap: "add recap",
  cart_summary: "cart summary",
  checkout: "checkout",
  event_setup: "event setup",
  select_shutterb: "select shutterb",
  add_reel: "add recap",
  cart: "cart",
  payment: "payment",
  promo_code_has_expired: "promo code has expired.",
  gift_card_has_expired: "shutterb credits has expired.",
  invalid_promo_code: "invalid promo code",
  invalid_gift_Card: "invalid shutterb credits",
  event_detail: "event details",
  shutterb_results: "shutterb results",
  go_back: "go back",

  //event setup---------------------------------------------------------------------------
  event_name: "event name:",
  please_enter_an_event_name: "please enter an event name",
  event_date: "event date:",
  please_select_an_event_date: "please select an event date",
  event_start_time: "event start time",
  event_time: "event time",
  event_location: "event location",
  enter_a_location: "enter a location",
  shutterb_start_time: "shutterb start time",
  loading: "loading...",
  location_description:
    "we are only servicing select cities in the GTA, Ontario, Ottawa, Edmonton Canada for now. If you are not in the GTA",
  location_description_next: " for updates on when we’ll be in your area.",
  additional_notes_description:
    "let us know anything else we should know about your event to ensure we capture everything!",
  appartment_unit_or_suite_no: "apartment, unit or suite number",
  please_select_an_event_type: "please select an event type",
  additional_notes: "additional notes",
  duration: "duration (hours)",
  event_duration: "shutterb duration",
  please_enter_a_duration: "please enter a duration",
  you_have_read_and_accepted: "you have read & accepted",
  terms_and_condition: "terms and conditions",
  you_must_accept_terms_and_conditions:
    "you must accept the terms and conditions",
  privacy_policy: "privacy policy",
  you_must_accept_privacy_policy: "you must accept the privacy policy",
  next: "next",
  please_add_additional_notes: "please add additional notes",
  added_to_cart: "shutterb(z) have been added to your cart",
  cart_is_empty: "cart is empty",
  please_enter_a_value_greater_than_or_equal_to_1:
    "please enter a value greater than or equal to 1",
  please_enter_a_value_less_than_or_equal_to_10:
    "please enter a value less than or equal to 10",
  contact_name: "on-site contact name",
  contact_number: "on-site contact phone number",
  add_another_event: "add another event",

  // ShutterB Profile
  reviews: "reviews",

  // Event Details
  generate_shortlist: "generate shortlist",
  onsite_contact_name: "onsite contact name",
  please_enter_a_onsite_contact_name:
    "please enter a onsite contact name for the event",
  onsite_contact_number: "onsite contact number",
  please_enter_a_onsite_contact_number:
    "please enter a onsite contact number for the event",
  add_optional_details: "add more details",
  please_enter_an_event_type: "please enter an event type",

  // Add Recap
  music_style: "music style",
  video_length: "video length",
  orientation: "orientation",
  upload_logo: "upload logo",
  please_fill_all_recap_feilds:
    "please complete all fields in each recap before proceeding.",

  //create password----------------------------------------
  password_has_been_set_successfully: "password has been set successfully",
  change_password: "change password",
  create_or_change_password: "create or change password",

  // Toast error handeling
  undefined: "something went wrong.",
  invalid_login: "invalid credentials.",
  invalid_input: "invalid input.",
  unable_to_access_server: "unable to access server.",
  internal_server_error: "internal server error.",
  email_sent_success: "email sent successfully",
  email_sent_failiure: "email sent failure",
  user_already_taken: "user name already exists.",
  user_already_exists: "user already exists.",
  email_is_taken: "sorry, this user email has already applied.",
  invalid_question_object: "invalid questions submission.",
  duplicate_value_exist: "one or more fields exists already.",
  object_not_exist: "object does not exist.",
  something_went_wrong: "something went wrong.",
  user_registration_failed: "user registration failed",
  not_active: "user is not active",
  user_not_active: "user is not active",
  username_incorrect: "username or password is incorrect",
  password_incorrect: "username or password is incorrect",
  email_not_verified: "email is not verified",
  password_reset_sent: "please check your email to set a new password.",
  email_not_found: "email not found",
  shot_list_not_found: "shot list not found",
  // ShutterB Selection---------------------------------------------------
  reserve: "reserve",
  view_profile: "view profile",

  //ShutterB gallery------------------------
  files_already_uploaded: "files already uploaded",
  no_id_exist: "no id exist",
  only_24_images_videos_and_recaps_are_allowed:
    "only 24 images, videos and recaps are allowed",
  no_shutterB_available_in_this_location:
    "no shutterB available in this location",
  please_unselect_videos: "please unselect videos",
  already_refered: "sorry, this email has already been sent a referral code.",
  reason_required: "reason is required",
  event_request_accepted: "event request accepted",
  event_request_declined: "event request declined",
  atleast_six_pic_required: "at least 6 images are required for portfolio",
  minimum_order_should_be: "minimum amount should be 2$, kindly contact admin.",
  additional_language: "additional language",
  you_will_receive_an_email_when_its_ready:
    "you will receive an email when download is ready",
  no_image:
    "sorry the event content is not ready yet, please check back within 24 hours of the event ending",
  no_files_uploaded: "no files uploaded yet!",
  download_files_email:
    "your request is being processed.  please allow for up to 10 minutes for this email to be sent to your inbox.",
  shutterb_start_time_message:
    "this is the time you would like your shutterb to arrive and begin shooting at your event.",
  event_location_message:
    "we are only servicing select cities in the GTA, Ontario, Ottawa, Edmonton Canada for now. if you are not in the GTA join our mailing list for updates on when we’ll be in your area.",
  yes: "yes",
  no: "no",
  skip: "skip",
  drag_drop_or_click_to_select:
    "drag & drop files here or click to select file(s)",
  image_size_exceeded: "the image size exceeds the 5 MB limit",
  please_upload_logo_image: "please upload logo",
  please_select_quantity: "please select at least one valid item with quantity",
  quantity_is_not_selected: "quantity is not selected",
  allow_sharing_gallery: "allow sharing gallery",
  review_your_order: "review your order",
  apply_coupon_code: "apply coupon/promo code:",
  billing_details: "billing details",
  apply: "apply",
  shutterb_permission:
    "rest assured, we won’t use your content for 7 days after event, allowing you ample time to lock or delete any images or videos you wouldn’t want us sharing",
  add_recaps: "add recap",
  are_you_sure_to_delete_event: "are you sure you want to delete this event?",
  are_you_sure_you_want_to_proceed:
    "you have some pending items in the cart, do you want to clear your cart and proceed?",
  confirm_switch_event_cart_clear:
    "you already have tip/extend items in your cart for another event. if you switch to a different event, your current cart will be cleared. do you want to continue?",

  proceed: "proceed",
  no_draft_event_exist: "no daft event exist",
  event_type: "event type",
  event_shot_list: "event shot list",
  no_event_available_for_edit: "event not found",
  token_not_found: "token not found.",
  token_is_expired: "token is expired.",
  admin_has_been_notified_to_assign_a_shutterb:
    "admin has been notified to assign a shutterb.",
  error_while_updating_configuration:
    "an error occurred while updating the configuration.",
  error_while_getting_configuration:
    "an error occurred while retrieving the configuration.",
  error_while_getting_events: "an error occurred while retrieving events.",
  error_while_creating_event: "an error occurred while creating event.",
  error_while_updating_event: "an error occurred while updating event.",
  error_while_getting_event_detail:
    "an error occurred while retrieving the event details.",
  error_while_caneling_event: "an error occurred while canceling the event.",
  error_while_getting_draft_events:
    "an error occurred while retrieving draft events.",
  error_while_getting_suggested_s_bz:
    "an error occurred while getting suggested SBz.",
  error_while_deleting_suggested_s_bz:
    "an error occurred while deleting suggested SBz.",
  error_while_informing_customer_about_suggested_s_bz:
    "an error occurred while informing customer about suggested SBz.",
  error_while_discarding_event: "an error occurred while discarding the event.",
  error_while_getting_event_detail_by_id:
    "an error occurred while retrieving the event details.",
  error_while_mapping_refund_dto_for_events:
    "an error occurred while mapping refund details for events.",
  error_while_retrieving_gift_cards:
    "an error occurred while retrieving shutterb credits details.",
  error_while_adding_gift_card:
    "an error occurred while adding a new shutterb credits.",
  error_while_toggling_gift_card_activation:
    "an error occurred while toggling the shutterb credits activation.",
  error_while_creating_affiliate_marketing:
    "an error occurred while creating the affiliate marketing record.",
  error_while_retrieving_affiliate_marketing_records:
    "an error occurred while retrieving affiliate marketing records.",
  error_while_updating_affiliate_marketing:
    "an error occurred while updating the affiliate marketing record.",
  error_while_retrieving_affiliate_marketing_by_id:
    "an error occurred while retrieving the affiliate marketing record by ID.",
  error_while_toggling_affiliate_marketing_link_activation:
    "an error occurred while toggling the affiliate marketing link activation.",
  error_while_retrieving_affiliate_marketing_reports:
    "an error occurred while retrieving affiliate marketing reports.",
  error_while_retrieving_payment_details:
    "an error occurred while retrieving payment details.",
  error_while_adding_postal_codes:
    "an error occurred while adding postal codes.",
  error_while_retrieving_postal_codes:
    "an error occurred while retrieving postal codes.",
  error_while_deleting_postal_code:
    "an error occurred while deleting the postal code.",
  error_while_retrieving_promo_codes:
    "an error occurred while retrieving promo codes.",
  error_while_updating_promo_code:
    "an error occurred while updating the promo code.",
  error_while_retrieving_promo_code_by_id:
    "an error occurred while retrieving the promo code by ID.",
  error_while_retrieving_promo_code_by_code:
    "an error occurred while retrieving the promo code by code.",
  error_while_toggling_discount_activation:
    "an error occurred while toggling the discount code activation.",
  error_while_creating_promo_code:
    "an error occurred while creating the promo code.",
  error_while_updating_reels_item:
    "an error occurred while updating the reels item.",
  error_while_retrieving_reels_data:
    "an error occurred while retrieving reels data.",
  error_while_retrieving_event_reels:
    "an error occurred while retrieving event reels.",
  error_while_retrieving_shutter_b_for_reels:
    "an error occurred while retrieving ShutterB users for reels.",
  error_while_removing_reel_assignee:
    "an error occurred while removing the reel assignee.",
  error_while_retrieving_reel_brief:
    "an error occurred while retrieving the reel brief.",
  error_while_adding_reel_type: "an error occurred while adding the reel type.",
  error_while_retrieving_reel_template_by_id:
    "an error occurred while retrieving the reel template by ID.",
  error_while_retrieving_reel_templates:
    "an error occurred while retrieving reel templates.",
  error_while_updating_reel_mode_configurations:
    "an error occurred while updating reel mode configurations.",
  error_while_retrieving_reel_mode_configurations:
    "an error occurred while retrieving reel mode configurations.",
  error_while_deleting_reel_template:
    "an error occurred while deleting the reel template.",
  error_while_retrieving_all_reels_of_event:
    "an error occurred while retrieving all reels of the event.",
  error_while_retrieving_shutter_b_list:
    "an error occurred while retrieving the ShutterB list.",
  error_while_updating_shutter_b:
    "an error occurred while updating ShutterB details.",
  error_while_updating_shutter_b_status:
    "an error occurred while updating ShutterB status.",
  error_while_retrieving_shutter_b_by_id:
    "an error occurred while retrieving ShutterB details by ID.",
  error_while_setting_hourly_rate_of_shutter_b:
    "an error occurred while setting the hourly rate of ShutterB.",
  error_while_adding_device: "an error occurred while adding the device.",
  error_while_retrieving_devices: "an error occurred while retrieving devices.",
  error_while_removing_device: "an error occurred while removing the device.",
  error_while_adding_shutter_b_on_website:
    "an error occurred while updating ShutterB display status on the website.",
  error_while_displaying_shutter_b_on_website:
    "an error occurred while fetching ShutterB details for display on the website.",
  error_while_removing_shutter_b_from_website:
    "an error occurred while removing the ShutterB from the website.",
  error_while_fetching_shutter_b_for_event:
    "an error occurred while fetching ShutterB details for the specified event.",
  error_while_reassigning_shutter_b_for_event:
    "an error occurred while reassigning ShutterB for the event.",
  error_while_removing_shutter_b_from_event:
    "an error occurred while removing ShutterB from the event.",
  error_while_reordering_devices: "an error occurred while reordering devices.",
  error_while_fetching_users: "an error occurred while fetching users.",
  error_while_fetching_user_by_id:
    "an error occurred while fetching user details.",
  error_while_updating_user:
    "an error occurred while updating the user details.",
  error_while_deleting_user: "an error occurred while deleting the user.",
  error_while_fetching_event_types:
    "an error occurred while fetching the list of event types.",
  error_while_fetching_event_type_items:
    "an error occurred while fetching the list of event type items.",
  error_while_fetching_event_by_id:
    "an error occurred while fetching the event details.",
  error_while_fetching_event_detail_by_event_id:
    "an error occurred while fetching the event details by Event ID.",
  error_while_fetching_all_events:
    "an error occurred while fetching all events.",
  error_while_saving_event: "an error occurred while saving the event.",
  error_while_saving_draft_event:
    "an error occurred while saving the draft event.",
  error_while_referring_to_friend:
    "an error occurred while referring a friend.",
  error_while_uploading_music_file:
    "an error occurred while uploading the music file.",
  error_while_fetching_event_type_shot_list:
    "an error occurred while fetching the shot list for the event type.",
  error_while_getting_edit_brief:
    "an error occurred while getting the edit brief.",
  error_while_fetching_draft_events:
    "an error occurred while fetching draft events for the given event group.",
  error_while_fetching_events_by_group_id:
    "an error occurred while fetching events for the specified event group.",
  error_while_fetching_events_to_edit:
    "an error occurred while fetching events to edit.",
  error_while_fetching_available_shutterb:
    "an error occurred while fetching available ShutterB for the event.",
  error_while_assigning_shutterb:
    "an error occurred while assigning the ShutterB to the event.",
  error_while_notifying_admin_for_shutterb_assignment:
    "an error occurred while notifying the admin to assign the ShutterB.",
  error_while_creating_stripe_order_payment:
    "an error occurred while creating Stripe order payment for the order.",
  error_while_fetching_user_event_gallery:
    "an error occurred while fetching the user event gallery.",
  error_while_removing_event_gallery_image:
    "an error occurred while removing the image from the event gallery.",
  error_while_locking_gallery_files:
    "an error occurred while locking/unlocking the gallery files.",
  error_while_fetching_attended_events:
    "an error occurred while fetching the attended events.",
  error_while_fetching_recent_searches:
    "an error occurred while fetching the recent searches.",
  error_while_fetching_shared_gallery_files:
    "an error occurred while fetching the shared gallery files.",
  error_while_favoriting_event_gallery_clip:
    "an error occurred while updating the favorite status of the event gallery clip.",
  error_while_fetching_shared_gallery_files_for_event_group:
    "an error occurred while fetching the shared gallery files for the event group.",
  error_while_grouping_event_gallery_for_user:
    "an error occurred while grouping the event gallery for the user.",
  error_while_adding_or_updating_review:
    "an error occurred while adding or updating the review.",
  error_while_fetching_user_review:
    "an error occurred while fetching the user review.",
  error_while_fetching_reel_price:
    "an error occurred while fetching the reel price.",
  error_while_fetching_shutterb_by_event:
    "an error occurred while fetching shutterB details for the event.",
  error_while_sending_message: "an error occurred while sending the message.",
  error_while_sending_message_board_email:
    "an error occurred while sending the message board email.",
  error_while_fetching_message_board_messages:
    "an error occurred while fetching the message board messages.",
  error_while_fetching_shutter_b_by_id:
    "an error occurred while fetching the ShutterB details.",
  error_while_bulk_updating_message_status:
    "an error occurred while updating the message status.",
  error_while_updating_message_status:
    "an error occurred while updating the message status.",
  error_while_fetching_notifications:
    "an error occurred while fetching notifications.",
  error_while_fetching_notification_count:
    "an error occurred while fetching the notification count.",
  error_while_fetching_event_group_recap:
    "an error occurred while fetching the event group recaps.",
  error_while_fetching_user_events:
    "an error occurred while fetching the user events.",
  error_while_fetching_admin_event_groups:
    "an error occurred while fetching admin event groups.",
  error_while_adding_recap: "an error occurred while adding the recap.",
  error_while_fetching_shutter_b_by_location:
    "an error occurred while fetching ShutterB users by location.",
  error_while_fetching_sb_profile_schedule:
    "an error occurred while fetching the ShutterB profile schedule.",
  error_while_adding_or_updating_portfolio:
    "an error occurred while adding or updating the portfolio.",
  error_while_deleting_gallery_image:
    "an error occurred while deleting the gallery image.",
  error_while_fetching_sb_portfolio:
    "an error occurred while fetching the ShutterB portfolio.",
  error_while_fetching_sb_info:
    "an error occurred while fetching the ShutterB information.",
  error_while_updating_sb_info:
    "an error occurred while updating the ShutterB information.",
  error_while_adding_schedule: "an error occurred while adding the schedule.",
  error_while_adding_portfolio_images:
    "an error occurred while adding images to the portfolio.",
  error_while_viewing_sb_profile:
    "an error occurred while fetching the ShutterB profile.",
  error_while_updating_profile_schedule:
    "an error occurred while updating the profile schedule.",
  error_while_downloading_event_files:
    "an error occurred while preparing the event files for download.",
  error_while_fetching_sb_event_reels:
    "an error occurred while fetching the ShutterB event reels.",
  error_while_fetching_sb_events_list:
    "an error occurred while fetching the ShutterB events list.",
  error_while_fetching_sb_my_events_list:
    "an error occurred while fetching your ShutterB events list.",
  error_while_processing_sb_event_acceptance:
    "an error occurred while processing the ShutterB event acceptance.",
  error_while_updating_check_status:
    "an error occurred while updating the ShutterB check status.",
  error_while_fetching_sb_event_gallery:
    "an error occurred while fetching the ShutterB event gallery.",
  error_while_saving_sb_event_files:
    "an error occurred while saving ShutterB event files.",
  error_while_creating_s3_folder_structure:
    "an error occurred while creating the folder structure on S3.",
  error_while_adding_event_gallery_details:
    "an error occurred while adding event gallery details.",
  error_while_generating_invoice:
    "an error occurred while generating the invoice.",
  error_while_creating_checkout_session:
    "an error occurred while creating the checkout session.",
  error_while_processing_stripe_payment:
    "an error occurred while processing the Stripe payment.",
  error_while_sending_event_email:
    "an error occurred while sending the event email.",
  error_while_fetching_admin_details:
    "an error occurred while fetching admin details.",
  error_while_fetching_extended_event_details:
    "an error occurred while fetching extended event details.",
  error_while_fetching_tipped_event_details:
    "an error occurred while fetching tipped event details details.",
  no_invoice_exist: "no invoice exist.",
  image_conversion_error: "image conversion failed.",
  please_upload_profile_picture: "please upload profile picture.",
  profile_image_format_not_supported: "profile image format not supported.",
  portfolio_min_images_required:
    "At least 8 (images, videos and recaps) are required for Portfolio",
  enter_precise_location: "enter precise location",
  please_enter_billing_details: "Please enter the billing details",
  country_is_required: "country is required",
  postal_code_is_required: "postal code is required",
  city_is_required: "city is required",
  state_province_is_required: "state/province is required",
  confirm_edit_event:
    "Changes to your event may impact the availability of your originally booked shutterbz. While we’ll do our best to keep them assigned, availability isn’t guaranteed.",
  cat_summary_table_recap_remove_message:
    "Updating recap requires updated recap breif, please navigate back to remove desired recap and review updated breif.",
  atleast_1_shutterb_required_message:
    "Atleast 1 shutterb is required for event.",
};

export default common_en;
